var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex flex-col items-center justify-center gap-2"},[_c('div',{staticClass:"text-xs text-illinois-text-muted text-center"},[_vm._v(" "+_vm._s(_vm.Title)+" ")]),_c('div',{staticClass:"flex items-center justify-center gap-2"},[_c('div',{staticClass:"text-base font-bold"},[_vm._v(_vm._s(_vm.segments[0].value))]),_c('DonutRing',{attrs:{"segments":_vm.segments,"size":35,"strokeWidth":4,"centerIcon":"corner","iconSize":12,"startAngle":_vm.segments[0].value > 0 || _vm.segments[1].value > 0
          ? (((_vm.segments[0].value + _vm.segments[1].value) / 2 -
              _vm.segments[0].value) /
              2 /
              (_vm.segments[0].value + _vm.segments[1].value)) *
              360 +
            90
          : 90}}),_c('div',{staticClass:"text-base font-bold"},[_vm._v(_vm._s(_vm.segments[1].value))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }